<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="image" src="images/p9.jpg"/><a id="page_9"></a></p><a id="page_9">
<p class="fm1"><b>Juliet Murphy, MBA</b></p>
<p class="txc">(714) 642-3777</p>
</a><p class="txc"><a id="page_9"></a><a href="http://www.julietmurphy.com" id="AZ9" target="_blank">www.julietmurphy.com</a></p>
<p class="txt1">Juliet Murphy, MBA and MA – Career Development, is the President of a career management company, Juliet Murphy Career Development (JMCD), delivering career solutions to young adults, executives and corporations. Her specialties include millennial career development, with Juliet having a strong background in working with new college graduates. Her website is: <i><a href="http://www.julietmurphy.com" id="AMS" target="_blank">www.julietmurphy.com</a></i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter10.vue?61e371f3